/**
 * @file 文件上传
 * @author svon.me@gmail.com
 */
// @ts-ignore
import config from "@/config";
// @ts-ignore
import {i18n} from "@/locales";
import * as _ from "lodash-es";
import UpdateBasis, {Status} from "./file";

function isFile(value: any) {
  return value instanceof File;
}

interface FileData {
  fileName: string;
  path: string;
  src: string;
  size: number;
  name: string;
}

const Upload = function (file: File | string | CanvasRenderingContext2D, data?: object): Promise<FileData> {
  const upload = new UpdateBasis({}, data || {});

  if (isFile(file)) {
    upload.setFile(file as File);
  } else if (_.isString(file)) {
    upload.setBase64(file);
  } else {
    upload.setCanvas(file as CanvasRenderingContext2D);
  }

  let flag: boolean = false;


  return new Promise(async function (resolve, reject) {
    const callback = function () {
      if (flag) {
        return false;
      }
      if (upload.status === Status.complete) {
        flag = true;
        resolve({
          size: upload.size,
          name: upload.name!,
          fileName: upload.name!,
          path: upload.url!,
          src: `${config.PREVIEW_DOMAIN}${upload.url}`,
        });
      } else if (upload.status === Status.abnormal) {
        if (upload.tryCount > 5) {
          flag = true;
          // 返回异常
          reject(i18n("common.uploadFail"));
        } else  {
          // 上传失败后尝试重新上传
          upload.again();
        }
      }
    }
    upload.on(callback);

    const status = await upload.start();
    if (flag) {
      return false;
    }
    if (!status) {
      return Promise.reject(i18n("common.uploadFail"));
    }
  });
}

export default Upload;